import { InjectedConnector } from '@web3-react/injected-connector'

export const CHAIN_ID = 80001;

export const injected = new InjectedConnector({
    // supportedChainIds: [1991],
    supportedChainIds: [80001],
})
// export const chainData = [
//     {
//         chainId: '0x38',
//         chainName: 'BSC Mainnet',
//         rpcUrls: ['https://bsc-dataseed.binance.org'],
//         blockExplorerUrls: ['https://bscscan.com'],
//     },
// ]
// export const chainData = [
//     {
//         chainId: '0x61',
//         chainName: 'BSC Testnet',
//         rpcUrls: ['https://bsc-testnet.publicnode.com'],
//         blockExplorerUrls: ['https://testnet.bscscan.com'],
//     },
// ]
// export const chainData = [
//     {
//         chainId: '0x61',
//         chainName: 'Mumbai',
//         rpcUrls: ['https://rpc-mumbai.maticvigil.com'],
//         blockExplorerUrls: ['https://mumbai.polygonscan.com'],
//     },
// ]
export const chainData = [
    {
        chainId: '0x13881',
        chainName: 'Mumbai',
        rpcUrls: ['https://bsc-testnet.publicnode.com'],
        blockExplorerUrls: ['https://mumbai.polygonscan.com'],
    },
]
